import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { normalizedLocale } from "../../../../common/libs/normalizedLocale";
import style from "./index.module.css"; // Импорт модуля стилей
import classNames from "classnames";
import Cookies from "js-cookie";
import { ChangingProductId } from "../../../../shared/components/ChangingProductId";
import { getOrganisationProductGroups } from "../../../../common/api/authApi";
import { product_groups } from "../../../../shared/reference/product_groups";

type OrganisationProductGroup = {
  id: number;
  organizationId: number;
  productGroupId: number;
  productGroupName: string;
  productGroupCode: string;
};

const LandingHeader = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState<number | undefined>(undefined);
  const { t, i18n } = useTranslation();
  // const locale = normalizedLocale(i18n.language);
  //@ts-ignore
  const locale = normalizedLocale(i18n.translator.language);
  const mapLocaleToPath = (locale: string) => {
    return locale === "kz" ? "kk" : locale || "en"; // Упрощение кода
  };
  const changeLng = (lng: "kk" | "ru") => {
    localStorage.setItem("i18nextLng", lng);
    i18n.changeLanguage(lng);
  };

  // Торговые группы и выбранная группа для селектора
  const [activeGroup, setActiveGroup] = useState<OrganisationProductGroup[]>([]);
  const [selectedGroupId, setSelectedGroupId] = useState<number | null>(null);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setMenuOpen(false);
    };

    setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Загрузка активных товарных групп и инициализация выбранной группы из куки
  useEffect(() => {
    const mapStaticToOrg = (list: any[]) =>
      list.map((pg: any) => ({
        id: pg.id,
        organizationId: 0,
        productGroupId: pg.id,
        productGroupName: pg.name,
        productGroupCode: pg.code,
      }));

    getOrganisationProductGroups()
      .then((activeGroups) => {
        const groups: any[] = Array.isArray(activeGroups) && activeGroups.length
          ? activeGroups
          : mapStaticToOrg(product_groups as any[]);

        setActiveGroup(groups);

        const fromCookie = Number(Cookies.get("activeGroup"));
        const valid = Number.isFinite(fromCookie) && groups.some((g: any) => g.productGroupId === fromCookie);
        const selectedProductGroupId = valid ? fromCookie : groups[0]?.productGroupId;

        setSelectedGroupId(selectedProductGroupId ?? null);

        // Сохраняем в cookies id и code
        Cookies.set("activeGroup", String(selectedProductGroupId), { expires: 180, path: "/" });
        const found = groups.find((g: any) => g.productGroupId === selectedProductGroupId);
        if (found?.productGroupCode) {
          Cookies.set("activeGroupCode", String(found.productGroupCode), { expires: 180, path: "/" });
        }
      })
      .catch((e) => {
        console.error("LandingHeader: не удалось загрузить товарные группы организации, используем справочник", e);
        const groups = mapStaticToOrg(product_groups as any[]);
        setActiveGroup(groups);

        const fromCookie = Number(Cookies.get("activeGroup"));
        const valid = Number.isFinite(fromCookie) && groups.some((g: any) => g.productGroupId === fromCookie);
        const selectedProductGroupId = valid ? fromCookie : groups[0]?.productGroupId;
        setSelectedGroupId(selectedProductGroupId ?? null);
        Cookies.set("activeGroup", String(selectedProductGroupId), { expires: 180, path: "/" });
        const found = groups.find((g: any) => g.productGroupId === selectedProductGroupId);
        if (found?.productGroupCode) {
          Cookies.set("activeGroupCode", String(found.productGroupCode), { expires: 180, path: "/" });
        }
      });
  }, []);

  return (
    <header className={style.headerMain}>
      <nav className={style.headerNav}>
        <a href={`/`}>
          <img
            src={`/icons/e-track-logo${locale === 'kk' ? '-kz' : ''}.svg`}
            alt="Logo"
            className={style.etrackLogo}
            width={182}
            height={26}
          />
        </a>
      </nav>
      <div className={style.headerSetting}>
        <button
          type="button"
          onClick={(e) => {
            changeLng("kk");
          }}
        >
          <span
            className={classNames(
              style.lngButton,
              locale === "kk" ? "font-bold" : "",
              " font-medium  p-[10px] block",
            )}
          >
            {t("common.kazakh_short")}
          </span>
        </button>
        <button
          type="button"
          onClick={(e) => {
            changeLng("ru");
          }}
          className={classNames(" font-bold")}
        >
          {" "}
          <span
            className={classNames(
              style.lngButton,
              locale === "ru" ? "font-bold" : "",
              " font-medium  p-[10px] block",
            )}
          >
            {t("common.russian_short")}
          </span>
        </button>
      </div>
    </header>
  );
};

export default LandingHeader;
